/**
 * Full Stack FastAPI MARIADB
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Modelo simplificado para los selectores del frontend.
 */
export interface TeamOptionResponse { 
    id: string;
    name: string;
}

